<p-toast></p-toast>
<div class="login-page">
  <div class="login-bg-img">
    <img src="./assets/images/login-bg-img.webp" alt="">
  </div>
  <div class="container">
    <div class="login-container">
      <div class="welcome">
        <h2>Welcome Petrie</h2>
        <p>Please enter your details to sign in.</p>
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="">
        <h4>Login</h4>
        <input type="text" pInputText placeholder="Email" formControlName="email" />

        <p-password [toggleMask]="true" formControlName="password" [feedback]="false" placeholder="Password"></p-password>
        
        <div class="pass-setup">
          <div class="remember">
            <p-checkbox formControlName="checked" [binary]="true" />
            <p class="m-0">Remember Me</p>
          </div>
          <div>
            <a (click)="navigateToForgetPassword()">Forgot Password</a>
          </div>
        </div>
        <p-button type="submit" class="w-100" styleClass="w-100" label="Login" class="p-button-primary mt-2"></p-button>
      </form>
    </div>
  </div>
</div>